import { API_ROUTES } from "../constants/routes";
import axios from "axios";

export default class AUTH_SERVICE {
  static login = async (email, password) => {
    try {
      const res = await axios.post(API_ROUTES.Auth.LOGIN, { email, password });
      return res?.data;
    } catch (error) {
      return error.response?.data;
    }
  };
}

